<template>
  <div class="row align-center justify-center">
    <div class="container justify-content-between align-items-center">
      <img src="https://beneflex-icons.s3.amazonaws.com/clients/logo1.svg" />
      <h1 color="primary">Iniciar Sesión</h1>
      <v-form ref="form" v-model="valid" lazy-validation class="col-md-6 col-sm-8">
        <v-text-field id="correo" label="Correo" placeholder="Ingrese un correo" append-icon="mdi mdi-account-outline"
          outlined color=primary v-model="user.correo" :rules="correoRules" :counter="200" :maxlength="200"
          required></v-text-field>

        <v-text-field id="contrasena" label="Contraseña" placeholder="Ingrese la contraseña"
          :append-icon="marker ? 'mdi-eye' : 'mdi-eye-off'" outlined v-model="user.contrasenia" :type="type"
          :rules="contraseniaRules" color=primary :counter="15" :maxlength="15" name="contrasenia" required
          autocomplete="on" v-on:keyup.enter="validate" @click:append="showpassword"></v-text-field>
        <br />
        <v-btn large block rounded :loading="loading" color="primary" @click="validate(); loader = 'loading'"
          style="color: white; border-radius: 50px;">
          Ingresar
        </v-btn>
        <passwordValidation v-if="dialog" :forgottenPass="forgottenPass">
        </passwordValidation>
      </v-form>
      <validationEmailLogin />
      <validationCodeLogin v-if="dialogEmail" :validateProps="timeLogin">
      </validationCodeLogin>
    </div>
  </div>
</template>

<script>

import {
  LOGIN_M,
  ACTION_LOGIN,
} from "@/views/login/store/types/types.js";
import actions_token from "@/plugins/http/actions_token/actions_token.js";
import passwordValidation from "@/views/login/pages/password_validation/password_validation_page.vue"
import validationEmailLogin from '@/views/recover_forgotten_password/page/validation_email/validation_email_page.vue';
import validationCodeLogin from '@/views/recover_forgotten_password/page/validation_code/validation_code_page.vue';

import { mapActions, mapGetters } from 'vuex';
import Swal from "sweetalert2";
import EventBus from '@/utils/event_bus.js';


export default {
  name: "formComponent",
  components: {
    passwordValidation,
    validationEmailLogin,
    validationCodeLogin,
  },
  mounted() {
    EventBus.$on('modal', (forgottenPass) => {
      this.forgottenPass = forgottenPass;
      this.dialog = true;
    });

    EventBus.$on('modal-validateEmail', (time) => {
      this.timeLogin = time;
      this.dialogEmail = true;
    });

    EventBus.$on('clear', () => {
      this.user = {
        correo: null,
        contrasenia: null
      };
    });
  },

  data() {
    return {
      timeLogin: 0,
      dialog: false,
      dialogEmail: false,
      forgottenPass: false,
      valid: true,
      loading: false,
      loader: null,
      correoRules: [
        v => !!v || "Campo requerido",
        v => /.+@.+\..+/.test(v) || "Correo electrónico inválido",
        v => v.length <= 200 || 'El correo debe tener máximo 200 caracteres',
      ],
      marker: true,
      type: "password",
      contraseniaRules: [
        v => !!v || "Campo requerido",
        v => v.length >= 8 || 'La contraseña debe tener mínimo 8 caracteres',
        v => v.length <= 15 || 'La contraseña debe tener máximo 15 caracteres',
      ],
      user: {
        correo: null,
        contrasenia: null,
      },

    }
  },

  watch: {
    loader() {
      const l = this.loader
      this[l] = !this[l]
      setTimeout(() => (this[l] = false), 3000)
      this.loader = null
    },
  },

  methods: {
    ...mapActions({
      iniciarSesion: `${LOGIN_M}${ACTION_LOGIN}`
    }),

    ...mapGetters({

    }),
   
    async validate() {
      if (!this.$refs.form.validate()) {
        return Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Debes diligenciar los campos',
          confirmButtonColor: '#6E17A5'
        })
      } else {
        this.user.correo = this.user.correo.toLowerCase();
        await actions_token._createdToken(this.user);
        const token = JSON.parse(sessionStorage.getItem('token'));

        if (token) {
          this.iniciarSesion(this.user).catch(() => {
            sessionStorage.clear();
          });
        }
      }
    },

    showpassword() {
      this.type = this.type === "password" ? "text" : "password";
      this.marker = !this.marker;
    },

  },
};
</script>

<style lang="css" scoped>
body {
  font-family: 'Nunito Sans', sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Amsi Pro', sans-serif;
}

img {
  width: 40vh;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 3vh;
  color: #6E17A5;
}

@media screen and (max-width: 500px) {
  .row {
    padding-top: 10vh;
    margin: auto;
  }
}
</style>